<template>
  <div class="videoWrapper">
    <lazy-component tag="div">
      <iframe
        v-if="videoId"
        width="640"
        height="360"
        style="border: none"
        :src="'//player.vimeo.com/video/' + videoId"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
      />
    </lazy-component>
  </div>
</template>

<script>
export default {
  props: {
    videoId: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss">
@import '../../assets/style/vars';
@import '../../assets/style/utils';

.videoWrapper {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  padding-top: 25px;
  height: 0;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
